<section class="features">
  <h2>{{ preferences.t('landing.features.title') }}</h2>

  <div class="feature-grid">
    @for (feature of features; track feature.key) {
      <article class="feature-card">
        <div class="icon-wrap">
          <app-icon [name]="feature.icon" />
        </div>
        <h3>{{ preferences.t('landing.features.items.' + feature.key + '.title') }}</h3>
        <p>{{ preferences.t('landing.features.items.' + feature.key + '.description') }}</p>
      </article>
    }
  </div>
</section>
